/**
 * Unified content enums and defaults.
 */

export const CONTENT_PREVIEW_LENGTH = 220;

export const CONTENT_STATUS = Object.freeze({
  DRAFT: "draft",
  PUBLISHED: "published",
});

export const CONTENT_VISIBILITY = Object.freeze({
  PUBLIC: "public",
  PRIVATE: "private",
  PREMIUM: "premium",
});

/** Canonical stored `type`: prose and poetry unify as `story` (+ `metadata.genre`); articles stay separate. */
export const CONTENT_TYPE = Object.freeze({
  STORY: "story",
  ARTICLE: "article",
});

/**
 * Legacy `type` field on content documents (historical / compatibility).
 * New work should use `metadata.genre` for discovery; prefer `STORY` as a neutral default when saving.
 */

/** Unified public catalog route segment (genre-first; no per-type lists). */
export const UNIFIED_CATALOG_SLUG = "read";

export function isUnifiedCatalogSlug(slug) {
  return String(slug || "").toLowerCase() === UNIFIED_CATALOG_SLUG;
}

/** Legacy URL segment `/${segment}` → stored `type` (articles only; other slugs normalize to `story`). */
export const EXPLORE_SLUG_TO_TYPE = Object.freeze({
  articles: CONTENT_TYPE.ARTICLE,
});

export const TYPE_TO_EXPLORE_SLUG = Object.freeze({
  [CONTENT_TYPE.ARTICLE]: "articles",
});

export const ALL_EXPLORE_SLUGS = Object.keys(EXPLORE_SLUG_TO_TYPE);

export const DEFAULT_LANGUAGE = "en";

export function exploreSlugToType(slug) {
  return EXPLORE_SLUG_TO_TYPE[slug] || CONTENT_TYPE.STORY;
}

export function typeToExploreSlug(type) {
  return TYPE_TO_EXPLORE_SLUG[type] || UNIFIED_CATALOG_SLUG;
}

/** Normalize stored type values for comparisons and filters. */
export function normalizeContentType(typeValue) {
  const raw = String(typeValue || "").trim().toLowerCase();
  if (!raw) return CONTENT_TYPE.STORY;
  if (Object.values(CONTENT_TYPE).includes(raw)) return raw;
  if (EXPLORE_SLUG_TO_TYPE[raw]) return EXPLORE_SLUG_TO_TYPE[raw];
  return CONTENT_TYPE.STORY;
}
